import React from 'react';
import { FaFacebook, FaInstagram, FaLinkedin, FaTwitter, FaYoutube } from 'react-icons/fa';
import { Button } from '../../globalStyles';
import { FooterContainer, FooterSubHeading, FooterSubscription, FooterSubText, Form, FormInput, FooterLinksContainer, FooterLink, FooterLinkTitle, FooterLinksItem, FooterLinksWrapper, SocialMedia, SocialMediaWrap, SocialLogo, WebsiteRights, SocialIcon, SocialIcons, SocialIconLink } from './Footer.elements';

const Footer = () => {
    return (
        <FooterContainer>
            <FooterSubscription>
                <FooterSubHeading>
                    Join now our exclusive membership to receive latest news and trends
                </FooterSubHeading>
                <FooterSubText>
                    You can unsubscribe at anytime
                </FooterSubText>
                <Form name='contact-form' method='POST' data-netlify='true'> 
                    <FormInput type='hidden' name='form-name' value='contact-form' />
                    <FormInput name='email' type='email' placeholder='enter email' />
                    <Button type='submit' fontBig>Subscribe</Button>  
                </Form>
                
            </FooterSubscription>
            <FooterLinksContainer>
                <FooterLinksWrapper>
                    <FooterLinksItem>
                        <FooterLinkTitle>About Us</FooterLinkTitle>
                        <FooterLink to='/sign-up'>How to get started</FooterLink>
                        <FooterLink to='/'>Our Work</FooterLink>
                        <FooterLink to='/'>Terms of Service</FooterLink>
                    </FooterLinksItem>
                    <FooterLinksItem>
                        <FooterLinkTitle>Contact Us</FooterLinkTitle>
                        <FooterLink to='/sign-up'>Subscribe</FooterLink>
                        <FooterLink to='/form'>Contact</FooterLink>
                        <FooterLink to='/sign-up'>Email</FooterLink>
                    </FooterLinksItem>
                    </FooterLinksWrapper>
                    <FooterLinksWrapper>
                    <FooterLinksItem>
                        <FooterLinkTitle>Social Media</FooterLinkTitle>
                        <FooterLink to='/'>Facebook</FooterLink>
                        <FooterLink to='/'>Twitter</FooterLink>
                        <FooterLink to='/'>Instagram</FooterLink>
                    </FooterLinksItem>
                </FooterLinksWrapper>
            </FooterLinksContainer>
            <SocialMedia>
                <SocialMediaWrap>
                    <SocialLogo to='/'>
                        <SocialIcon />
                        GoGlo
                    </SocialLogo>
                    <WebsiteRights>GoGlo &#169; 2021</WebsiteRights>
                    <SocialIcons>
                        <SocialIconLink href='https://www.facebook.com/Will_tech-103917778062069' target="_blank" aria-label='Facebook'>
                            <FaFacebook />
                        </SocialIconLink>
                        <SocialIconLink href='https://www.instagram.com/will_tech1/' target="_blank" aria-label='Instagram'>
                            <FaInstagram />
                        </SocialIconLink>
                        <SocialIconLink href='https://www.youtube.com/channel/UCIFcQ6eK2y9odRTEha4Z-Vw' target="_blank" aria-label='Youtube'>
                            <FaYoutube />
                        </SocialIconLink>
                        <SocialIconLink href='https://twitter.com/travisisap' target="_blank" aria-label='Twitter'>
                            <FaTwitter />
                        </SocialIconLink>
                        <SocialIconLink href='/https://www.linkedin.com/in/aphile-ntando-679b0918a/' target="_blank" aria-label='Linkedin'>
                            <FaLinkedin />
                        </SocialIconLink>
                    </SocialIcons>
                </SocialMediaWrap>
            </SocialMedia>
        </FooterContainer>
    )
}

export default Footer;
